<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <!--  <img :src="user.avatarb64" class="c-avatar-img" /> -->
          <b-avatar v-if="user.avatarb64" :src="user.avatarb64"></b-avatar>
          <b-avatar v-if="!user.avatarb64" :text="user.initials"></b-avatar>
        </div>
      </CHeaderNavLink>
    </template>
    <!--     <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-bell"/> Updates
      <CBadge color="info" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-envelope-open" /> Messages
      <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="danger" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>-->
    <!--  <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>-->
    <CDropdownHeader tag="div" class="text-center" color="light">
      <h4>
        <strong>{{ user.name }}</strong>
      </h4>
    </CDropdownHeader>

    <!--  <CDropdownItem to="/clients"> -->
    <!-- <CIcon name="cil-people" /> -->
    <!--  <i class="fa fa-user-circle"></i>
      Clients
    </CDropdownItem> -->


    <!-- <CDropdownItem to="/tasksviewer" v-if="user.rolename == 'admin'">
      <i class="fa fa-tasks"></i>
      Task Viewer
    </CDropdownItem> -->
    <!-- <CDropdownItem to="/documents" v-if="user.permissions.includes('documents')">
     
      <i class="fa fa-sitemap"></i>
      Documents
    </CDropdownItem> -->
    <CDropdownItem to="/profile">
      <!--  <CIcon name="cil-user" /> -->
      <i class="fa fa-user"></i>
      Profile
    </CDropdownItem>
    <CDropdownDivider v-if="user.rolename == 'admin'" />

    <!-- v-if="user.rolename == 'admin'" -->
    <!-- <CDropdownItem to="/users" v-if="permissionvalid('users.view') || permissionvalid('systems.development')">
      <i class="fa fa-user-circle"></i>
      Users (Old)
    </CDropdownItem> -->
    <!-- v-if="user.rolename == 'admin'" -->
    <CDropdownItem to="/setup_users" v-if="permissionvalid('users.view') || permissionvalid('systems.development')">
      <i class="fa fa-user-circle"></i>
      <!--   <CIcon name="cil-people" /> -->
      Users
    </CDropdownItem>
    <!-- <CDropdownItem to="/users2" v-if="user.permissions.includes('systems.development')">
      <i class="fa fa-user-circle"></i>


    v-if="user.rolename == 'admin' || user.permissions.includes('systems.taskscheduler')" -->
    <!-- <CDropdownItem to="/taskscheduler" v-if="permissionvalid('tasks.view')">
      <i class="fa fa-clock-o"></i>
      Task Scheduler
    </CDropdownItem> -->

    <!-- <CDropdownItem to="/taskscheduler2" v-if="user.permissions.includes('systems.development')">
      <i class="fa fa-clock-o"></i>
      Task Scheduler2
    </CDropdownItem> -->

    <!-- <CDropdownItem to="/taskscheduler" v-if="permissionvalid('tasks.view') || permissionvalid('systems.development')">
      <i class="fa fa-clock-o"></i>
      Tasks
    </CDropdownItem> -->
    <CDropdownItem to="/setup_tasksat" v-if="permissionvalid('tasks.view') || permissionvalid('systems.development')">
      <i class="fa fa-clock-o"></i>
      Tasks
    </CDropdownItem>

    <!-- v-if="user.rolename == 'admin' || user.permissions.includes('systems.log4net')" -->
    <CDropdownItem to="/log4net" v-if="permissionvalid('lognet.view') || permissionvalid('systems.development')">
      <!--    <CIcon name="cil-history" /> -->
      <i class="fa fa-history"></i>
      Log4Net
    </CDropdownItem>

    <!-- <CDropdownItem to="/settings" v-if="user.rolename == 'admin' || user.permissions.includes('systems.settings')">     
      <i class="fa fa-cog mr-1"></i>Settings
    </CDropdownItem> -->

    <CDropdownDivider />

    <!-- || user.permissions.includes('systems.settings')" -->
    <CDropdownItem to="/snapshot?name=API%20Pressure&call=report_apirequest" v-if="user.rolename == 'admin'">
      <i class="fa fa-thermometer-three-quarters text-danger mr-1"></i>API Pressure
    </CDropdownItem>

    <!-- || user.permissions.includes('systems.settings')" -->
    <CDropdownItem to="/setup_reports" v-if="user.rolename == 'admin'">
      <!--   <CIcon name="cil-settings" /> -->
      <i class="fa fa-cog mr-1"></i>Report Setup
    </CDropdownItem>

    <!-- || user.permissions.includes('systems.settings') -->
    <CDropdownItem to="/setup_systemsettings" v-if="user.rolename == 'admin'">
      <!--   <CIcon name="cil-settings" /> -->
      <i class="fa fa-cog mr-1"></i>System Setup
    </CDropdownItem>

    <!-- <CDropdownItem to="/settings" v-if="user.rolename == 'admin' || user.permissions.includes('systems.settings')">   
      <i class="fa fa-cog mr-1"></i>Setup System
    </CDropdownItem> -->

    <CDropdownDivider />
    <CDropdownItem to="/lock-account">
      <!--  <CIcon name="cil-shield-alt" /> -->
      <i class="fa fa-shield mr-1"></i>Lock Account
    </CDropdownItem>
    <CDropdownItem @click="$router.push('/logout')">
      <!--   <CIcon name="cil-lock-locked" /> -->
      <i class="fa fa-power-off mr-1"></i>Sign Out
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    runreport(e, c) {
      console.log("run", e);
      if (c) {
        this.selectedComponent = c;
      } else {
        this.selectedComponent = "Report";
      }
      this.search = {
        name: e.label,
        call: e.id,
      };
    },
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>